import React from 'react';
import { Spin } from 'antd';

const LazyReactivateAccount = React.lazy(() => import('./Reactivate'));
export const AsyncReactivatePage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyReactivateAccount />
	</React.Suspense>
);
